module.exports = __webpack_public_path__ + "img/con2.0d301e31.png";